import React, { FC, useEffect } from "react";
import CN from "classnames";
import { useSelector } from "react-redux";
import DeliveryStatusUpdater from "./plugins/DeliveryStatusUpdater";
import StateUpdatePopup from "./plugins/StateUpdatePopup";
import { getDate } from "../OrderManage/helpers/dateConvertions";

export interface OrderDetailsProps {
  [x: string]: any;
}

export const OrderDetails: FC<OrderDetailsProps> = ({
  className,
  ...restProps
}: OrderDetailsProps) => {
  const oneOrderData = useSelector(
    (state: any) => state.rootReducer.orderDetail.oneOrderData
  );

  const orderData = restProps.state;

  console.log("orderData", orderData);
  console.log("oneOrderData", oneOrderData);

  return (
    <>
      <div className="flex flex-col my-20 px-10 text-center w-full">
        <div className="border rounded-lg p-3">
          <div className="flex text-primary text-base font-semibold mt-2">
            <h2>Order status</h2>
          </div>
          <hr className="border[1px] mt-3" />
          <div>
            <DeliveryStatusUpdater status={oneOrderData?.data.status} />
          </div>

          <StateUpdatePopup
            status={oneOrderData?.data.status}
            orderId={oneOrderData?.data._id}
          />
        </div>

        <div className="border rounded-lg p-3 mt-6">
          <div className="flex text-primary text-base font-semibold mt-2">
            <h2>Order Details</h2>
          </div>
          <hr className="border[1px] mt-3" />
          <div className="text-start mt-6">
            <div className="flex gap-16">
              <div className="flex flex-col">
                <h2 className="font-semibold">Order ID</h2>
                <h4 className="text-slate-500 mt-1 text-base font-medium">{`#${oneOrderData?.data?.orderCode}`}</h4>
              </div>

              <div className="flex flex-col">
                <h2 className="font-semibold">Order Placed on</h2>
                <h4 className="text-slate-500 mt-1 text-base font-medium">
                  {getDate(oneOrderData?.data?.createdAt)}
                </h4>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <h3 className="font-semibold text-lg">Order Summary</h3>
            <div className="grid grid-cols-3 gap-4 mt-4 font-medium text-sm">
              <span>Item</span>
              <span>Quantity</span>
              <span>Total</span>
            </div>
            {oneOrderData?.data?.products.map((product: any) => (
              <div
                key={product._id}
                className="grid grid-cols-3 gap-4 mt-2 text-sm border-2 border-gray-200 p-2"
              >
                <span className="block">
                  <b>{` Name: ${product?.productName}`}</b>
                  <br />
                  <b>{` Sku: ${product?.productSku}`}</b>
                  <br />
                  {` ID: ${product?.productId}`}
                </span>
                <span>{product?.productQty}</span>
                <span>
                  {`AED${product?.productPrice?.toFixed(2)}`}
                  <br />
                  {product.productDiscount
                    ? `Discount: AED${product?.productDiscount?.toFixed(2)}`
                    : null}
                </span>
              </div>
            ))}
            <div className="mt-4 font-semibold text-lg">
              <div className="grid grid-cols-3 gap-4">
                <span>Total</span>
                <span>{oneOrderData?.data?.orderQuntity}</span>
                <span>{`AED${(
                  oneOrderData?.data?.price + oneOrderData?.data?.discountPrice
                ).toFixed(2)}`}</span>
              </div>
              <div className="grid grid-cols-3 gap-4 mt-2">
                <span>Discount</span>
                <span></span>
                <span>{`-AED${oneOrderData?.data?.discountPrice.toFixed(
                  2
                )}`}</span>
              </div>
              <div className="grid grid-cols-3 gap-4 mt-2">
                <span>Grand Total</span>
                <span></span>
                <span>{`AED${oneOrderData?.data?.price.toFixed(2)}`}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border rounded-lg p-3 mt-6">
          <h3 className="font-semibold text-lg">Customer Details</h3>
          <div className="mt-4 text-sm text-slate-700 font-medium">
            <div className="mb-2">
              <span className="font-semibold">Name:</span>{" "}
              {`${oneOrderData?.data?.firstName} ${oneOrderData?.data?.lastName}`}
            </div>
            <div className="mb-2">
              <span className="font-semibold">Company:</span>{" "}
              {oneOrderData?.data?.companyName || "N/A"}
            </div>
            <div className="mb-2">
              <span className="font-semibold">Address:</span>
              <div className="ml-4">
                <p>{oneOrderData?.data?.address?.streetAddress}</p>
                <p>{`${oneOrderData?.data?.address?.city}, ${oneOrderData?.data?.address?.state} ${oneOrderData?.data?.address?.zipCode}`}</p>
              </div>
            </div>
            {oneOrderData?.data?.orderNote && (
              <div className="mb-2">
                <span className="font-semibold">Order Note:</span>{" "}
                {oneOrderData?.data?.orderNote}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
